import { InputOption } from "../../../shared/models/Input";

export interface DataForm {
	siret: InputOption,
	codeUrssaf: InputOption,
	codeNaf: InputOption,
	raisonSociale: InputOption,
	raisonSociale2: InputOption,
	codePostalEtablissement: InputOption,
	communeEtablissement: InputOption,
	adresseEtablissement: InputOption,
	nomNaissanceSalarie: InputOption,
	prenomSalarie: InputOption,
	dateNaissanceSalarie: InputOption,
	communeNaissanceSalarie: InputOption,
	paysNaissanceSalarie: InputOption,
	departementNaissanceSalarie: InputOption,
	numSecuriteSocialeSalarie: InputOption,
	dateEmbauche: InputOption,
	serviceSanteContrat: InputOption,
	dureePeriodeEssai: InputOption,
	heureEmbauche: InputOption,
	natureContrat: InputOption,
	dateFinCdd: InputOption,
	dateDepotDemande: InputOption
}

export const dataFormBase: DataForm = {
	siret: {
		vmodel: "",
		label: "N° SIRET *",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: true,
		checkEvenIfDisabled: true,
		max: 14
	},
	codeUrssaf: {
		vmodel: "",
		label: "Code URSSAF *",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: true,
		checkEvenIfDisabled: true,
		max: 4
	},
	codeNaf: {
		vmodel: "",
		label: "Code NAF *",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: true,
		checkEvenIfDisabled: true,
		max: 5
	},
	raisonSociale: {
		vmodel: "",
		label: "Raison sociale *",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: true,
		checkEvenIfDisabled: true,
		max: 32
	},
	raisonSociale2: {
		vmodel: "",
		label: "Raison sociale 2",
		trigger: false,
		required: false,
		error: false,
		clear: false,
		reset: false,
		disabled: true,
		checkEvenIfDisabled: true,
		max: 32
	},
	codePostalEtablissement: {
		vmodel: "",
		label: "Code postal établissement *",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: true,
		checkEvenIfDisabled: true,
		max: 5
	},
	communeEtablissement: {
		vmodel: "",
		label: "Commune établissement *",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: true,
		checkEvenIfDisabled: true,
		max: 32
	},
	adresseEtablissement: {
		vmodel: "",
		label: "Adresse établissement *",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: true,
		checkEvenIfDisabled: true,
		max: 32
	},
	nomNaissanceSalarie: {
		vmodel: "",
		label: "Nom de naissance *",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: true,
		checkEvenIfDisabled: true,
		max: 32
	},
	prenomSalarie: {
		vmodel: "",
		label: "Prénom *",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: true,
		checkEvenIfDisabled: true,
		max: 32
	},
	dateNaissanceSalarie: {
		vmodel: "",
		label: "Date de naissance *",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: true,
		checkEvenIfDisabled: true,
		max: 24
	},
	communeNaissanceSalarie: {
		vmodel: "",
		label: "Commune de naissance *",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: true,
		checkEvenIfDisabled: true,
		max: 32
	},
	paysNaissanceSalarie: {
		vmodel: "",
		label: "Pays de naissance",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: true,
		checkEvenIfDisabled: true,
		max: 50
	},
	departementNaissanceSalarie: {
		vmodel: "",
		label: "Département de naissance *",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: true,
		checkEvenIfDisabled: true,
		max: 4
	},
	numSecuriteSocialeSalarie: {
		vmodel: "",
		label: "N° de sécurité sociale *",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: true,
		checkEvenIfDisabled: true,
		max: 15
	},
	dateEmbauche: {
		vmodel: "",
		label: "Date d'embauche *",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: true,
		checkEvenIfDisabled: true,
		max: 24
	},
	serviceSanteContrat: {
		vmodel: "",
		label: "Service santé au travail *",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: true,
		checkEvenIfDisabled: true,
		max: 50
	},
	dureePeriodeEssai: {
		vmodel: "",
		label: "Durée de la période d'essai",
		trigger: false,
		required: false,
		error: false,
		clear: false,
		reset: false,
		disabled: true,
		checkEvenIfDisabled: true,
		max: 50
	},
	heureEmbauche: {
		vmodel: "",
		label: "Heure d'embauche *",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: true,
		checkEvenIfDisabled: true,
		max: 24
	},
	natureContrat: {
		vmodel: "",
		label: "Code nature du contrat *",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: true,
		checkEvenIfDisabled: true,
		max: 50
	},
	dateFinCdd: {
		vmodel: "",
		label: "Date de fin prévisionnelle du CDD",
		required: false,
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: true,
		max: 24,
		checkEvenIfDisabled: true
	},
	dateDepotDemande: {
		vmodel: "",
		label: "Date de dépôt de la demande",
		required: false,
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: true,
		max: 24,
		checkEvenIfDisabled: true
	}
};



// WEBPACK FOOTER //
// ./src/components/dpae/modalDemandeDpae/demandeDpaeModel.ts